import styled from 'styled-components';

export const Mark = styled.mark`
  padding: 0 0.1em;
  border-radius: 0.15em;
  background-color: var(--mark-bg);
  color: var(--mark-text);
`;
